<template>
  <div>
    <el-date-picker
        v-model="time"
        :picker-options="pickerOptions"
        ref="datetime"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="dateChange"
    ></el-date-picker>
  </div>
</template>

<script>
import moment from 'moment'

const DateFormat = 'YYYY-MM-DD'
const TimeFormat = 'HH:mm:ss'
const ENDTimeFormat = '23:59:59'
const Format = 'YYYY-MM-DD HH:mm'

export default {
  name: "DatePicker",
  props: {
    dateValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      time: [], 
      pickerOptions: {
        disabledDate: time => {
          return moment().subtract(1, "days") >= time.getTime();
        },
        onPick: ({ minDate, maxDate }) => {
          if (!(minDate && maxDate)) {
            return
          }
          const picker = this.$refs.datetime.picker
          const { minTimePicker, maxTimePicker } = picker.$refs
          const today = new Date();
          const pickStartDate = moment(minDate).format(DateFormat) 
          const pickEndDate = moment(maxDate).format(DateFormat) 
          const startDate = moment(today).format(DateFormat)
          const minStartTime = moment(today).format(TimeFormat) 
          const maxStartTime = moment(today.getTime() + 1000 * 60).format(TimeFormat) 
          
          if (pickStartDate === startDate) {
            minTimePicker.selectableRange = [
              [new Date(`${startDate} ${minStartTime}`), new Date(`${startDate} ${ENDTimeFormat}`)]
            ]
          } else {
            minTimePicker.selectableRange = []
          }
          if (pickEndDate === startDate) {
            maxTimePicker.selectableRange = [
              [new Date(`${startDate} ${maxStartTime}`), new Date(`${startDate} ${ENDTimeFormat}`)]
            ]
          } else {
            maxTimePicker.selectableRange = []
          }
        }
      }
    }
  },
  watch: {
    dateValue: {
      handler: function (val) {
        this.time = val
      }
    }
  },
  methods: {
    dateChange(e) {
      let dateRange = e;
      if (e && e.length > 1) {
        const todayTime= new Date(moment(new Date()).format(Format)).getTime();
        const start = new Date(dateRange[0]).getTime();
        const end = new Date(dateRange[1]).getTime();
        
        if (start < todayTime) {
          this.$message.warning('直播开始时间需大于当前时间！');
          this.time = null;
        } else if (start >= end) {
          this.$message.warning('直播结束时间需大于直播开始时间！');
          this.time = null;
        } else {
          this.time = dateRange;
        }
        this.$emit('dateChange', this.time);
      } else {
        this.$emit('dateChange', e);
      }
    }
     
  }
}
</script>